let thisElement = null;
let isAmountAdjusting = false;
let isLoadingAdjuster = false;
let isFistTimePageLoad = true;
let pendingUpdates = new Map();
let isAmountAdjust = false; // FIXED: Global scope mein move kiya

$(document).ready(function () {
    // FIXED: isAmountAdjust yahan se hataya (pehle let isAmountAdjust = !1 tha jo local tha)
    window.veriff = {
        result: null,
    };

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    $(".appoinment_icon_wrapp .appoinment_contant_wrapp.without_homepage_header a").click(function () {
        setCookie("appointmentform", "appointmentform", 1);
    });
    $(".main_claculator-right-part .right-side-bottom a.btn").click(function () {
        setCookie("appointmentform", "appointmentform", 1);
    });
    $(".custom-first-menu-here").click(function () {
        $(this).parents("li.slide-nav__item").toggleClass("active-menu");
    });

    jQuery.getJSON("/cart.js", function (cart) {
        var original_price = cart.total_price,
            total_goal = $(".sidebar_progress_bar").attr("data-goal"),
            final_result = original_price / 100;
        if (final_result >= total_goal) {
            $("span.minus_val").hide();
            $(".free_shipping_text").show();
        } else if (final_result < total_goal) {
            $(".free_shipping_text").hide();
        }
    });

    $("ul.site-nav li.site-nav--has-dropdown").mouseleave(function () {
        $("body").removeClass("on_header_hover");
    });
    $("ul.site-nav li.site-nav--has-dropdown").mouseenter(function () {
        $("body").addClass("on_header_hover");
    });

    $(document).on("change", "input[type=date]", function () {
        var data_value_get = $(this).val();
        if (data_value_get !== "") {
            $(this).removeClass("placeholder_shown");
            $(this).addClass("placeholder_hide");
        } else {
            $(this).addClass("placeholder_shown");
            $(this).removeClass("placeholder_hide");
        }
    });

    $(document).on("focus", "input[type=date]", function () {
        var data_value_get = $(this).val();
        if (data_value_get !== "") {
            $(this).removeClass("placeholder_shown");
            $(this).addClass("placeholder_hide");
        } else {
            $(this).addClass("placeholder_shown");
            $(this).removeClass("placeholder_hide");
        }
    });

var disabledDates = [ "2024-07-29", "2024-07-30", "2024-07-31", "2024-08-01", "2024-08-02", "2024-08-03", "2024-08-04", "2024-08-05", "2024-08-06", "2024-08-07", "2024-08-08", "2024-08-09", "2024-08-10", "2024-08-11", "2024-08-12", "2024-08-13", "2024-08-14", "2024-08-15", "2024-08-16", "2024-08-17", ];

    $("#datepic_client_date, #second_datepic_client_date").datepicker({
        minDate: new Date(),
        dateFormat: "yy-mm-dd",

        beforeShowDay: function (date) {
            var dayOfWeek = date.getDay();
            var formattedDate = $.datepicker.formatDate("yy-mm-dd", date);
            var today = new Date();
            var isToday = formattedDate === $.datepicker.formatDate("yy-mm-dd", today);
            var isDisabledDate = disabledDates.indexOf(formattedDate) !== -1;
            var isWeekend = dayOfWeek === 0 || dayOfWeek === 1;
            /* ---------------------------------------
               NEW : Agency Holiday Check
            --------------------------------------- */
            var selectedAgency = $("#agency-id").val();
            if (selectedAgency) {
                var holiday = isAgencyClosed(selectedAgency, formattedDate);
                if (holiday.status) {
                    console.log("🚫 Holiday:", selectedAgency, formattedDate);
                    return [false, "disabled", "Agency Closed"];
                }
            }
            /* --------------------------------------- */
            if (
                (isToday && isWeekend) ||
                isDisabledDate ||
                isWeekend
            ) {
                return [false, "disabled"];
            }
            return [true, ""];
        },
        onSelect: function (dateText) {
            var selectedDate = $(this).datepicker("getDate");
            var dayOfWeek = selectedDate.getDay();
            // Move Sunday/Monday to next valid day
            if (dayOfWeek === 0 || dayOfWeek === 1) {
                selectedDate.setDate(
                    selectedDate.getDate() + (dayOfWeek === 0 ? 2 : 1)
                );
                $(this).datepicker("setDate", selectedDate);
            }
            // Format as YYYY-MM-DD
            var formattedDate = $.datepicker.formatDate(
                "yy-mm-dd",
                selectedDate
            );
            // Update the hidden input in THIS form only
            $(this)
                .closest("form")
                .find('input[name="client_date"]')
                .val(formattedDate);

            console.log("Selected Date:", formattedDate);
        }
    });
    // ============================================
    // CART ADJUSTMENT LOGIC
    // ============================================
    adjustAmount(true);
    $(document).on("CartDrawer:open drawerOpen ajaxProduct:added", () => {
        adjustAmount(false);
    });

    $(document).on("cart:updated", () => {
        console.log("cart:updated");
        adjustAmount(false);
        if (!isFistTimePageLoad) {
            setTimeout(() => {
                window.location.reload();
            }, 500);
        }
    });

    // Handle typing in the adjust value input
    $(".adjust-value").on("keyup", function (e) {
        isAmountAdjusting = true;
    });

    // Only update attributes on change, do NOT call change.js yet
    $(".adjust-value").on("change", function (e) {
        const $input = $(this);
        const itemKey = $input.parents(".cart__item").data("key");
        isAmountAdjusting = true;
        let newVal = parseFloat($input.val().replace(/[^0-9.]/g, "").replace(/(\..*?)\..*/g, "$1"));
        let itemAmount = parseFloat($input.data("value"));
        let symbol = newVal > itemAmount ? "+" : "-";
        let remainAmount = Math.abs(itemAmount - newVal);
        // Update the data attributes
        $input.attr("data-adjust_symbol", symbol);
        $input.attr("data-adjust_amount", remainAmount);
        // Store the current element data
        thisElement = {
            symbol: symbol,
            remainAmount: remainAmount,
            id: $input.data("id"),
            qty: $input.parents(".cart__item").find(".js-qty__num").val(),
        };
        // Store in pending updates with all necessary data
        pendingUpdates.set(itemKey, {
            key: itemKey,
            $input: $input,
            quantity: Number($input.parents(".cart__item").find(".js-qty__num").val() || 1),
            adjustAmount: remainAmount,
            adjustSymbol: symbol,
        });
        // Update the display immediately (visual feedback only)
        adjustAmount(false);
        console.log("Price changed, waiting for blur/click outside to save...");
    });
    // Call change.js only when input loses focus
    $(".adjust-value").on("blur", async function (e) {
        const $input = $(this);
        const itemKey = $input.parents(".cart__item").data("key");
        if (pendingUpdates.has(itemKey)) {
            console.log("Input blurred, updating cart...");
            isLoadingAdjuster = true;
            await updateSingleLineItem($input);
            pendingUpdates.delete(itemKey);
            isAmountAdjusting = false;
            isLoadingAdjuster = false;
            adjustAmount(false);
        }
    });

    // Checkout button handler
    $(document).on("click", "#myBtn", async function (e) {
        e.preventDefault();
        $(".customer_exist").removeClass("required");
        if ($(".customer_exist").length > 0 && $(".customer_exist").val() == "") {
            $(".customer_exist").addClass("required").focus();
            return;
        }
        // Wait for any pending updates to complete
        if (pendingUpdates.size > 0) {
            await updateAllPendingLineItems();
        }
        initViriffCheckout();
    });

    $(document).on("click", "#myModalClose", function (e) {
        $("#myModal").hide();
    });

    // Call change.js when clicking outside the input
    $(document).on("click", async function (e) {
        if (!$(e.target).hasClass("adjust-value") && !$(e.target).closest(".adjust-value").length) {
            if (pendingUpdates.size > 0) {
                console.log("Clicked outside, updating all pending items...");
                await updateAllPendingLineItems();
            }
        }
    });

    // Also update when switching to another adjust-value input
    $(document).on("focus", ".adjust-value", async function (e) {
        const currentKey = $(this).parents(".cart__item").data("key");
        if (pendingUpdates.size > 0) {
            const itemsToUpdate = Array.from(pendingUpdates.values()).filter(item => item.key !== currentKey);
            if (itemsToUpdate.length > 0) {
                console.log("Switching to another input, updating previous item...");
                isLoadingAdjuster = true;
                for (const itemData of itemsToUpdate) {
                    await updateSingleLineItemFromData(itemData);
                    pendingUpdates.delete(itemData.key);
                }
                isLoadingAdjuster = false;
                adjustAmount(false);
            }
        }
    });
});

function addJsScript(src) {
    var script = document.createElement("script");
    script.src = src;
    document.head.appendChild(script);
}

// ============================================
// Update a single line item from input element
// ============================================
async function updateSingleLineItem($input) {
    const itemKey = $input.parents(".cart__item").data("key");
    const quantity = Number($input.parents(".cart__item").find(".js-qty__num").val() || 1);
    const adjustAmt = $input.attr("data-adjust_amount");
    const adjustSymbol = $input.attr("data-adjust_symbol");
    try {
        console.log("Calling /cart/change.js for item:", itemKey);
        const response = await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                id: itemKey,
                quantity: quantity,
                properties: {
                    _adjust_amount: adjustAmt,
                    _adjust_symbol: adjustSymbol,
                },
            }),
        });
        const result = await response.json();
        if (result.status === "bad_request") {
            console.error("Cart update error:", result.message);
            return null;
        }
        console.log("Item updated successfully:", result);
        return result;
    } catch (error) {
        console.error("Error updating item:", error);
        return null;
    }
}

// ============================================
// Update a single line item from stored data
// ============================================
async function updateSingleLineItemFromData(itemData) {
    try {
        console.log("Calling /cart/change.js for item:", itemData.key);
        const response = await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                id: itemData.key,
                quantity: itemData.quantity,
                properties: {
                    _adjust_amount: itemData.adjustAmount,
                    _adjust_symbol: itemData.adjustSymbol,
                },
            }),
        });
        const result = await response.json();
        if (result.status === "bad_request") {
            console.error("Cart update error:", result.message);
            return null;
        }
        console.log("Item updated successfully:", result);
        return result;
    } catch (error) {
        console.error("Error updating item:", error);
        return null;
    }
}

// ============================================
// Update all pending line items
// ============================================
async function updateAllPendingLineItems() {
    if (pendingUpdates.size === 0) return;
    isLoadingAdjuster = true;
    isAmountAdjusting = true;
    console.log("Updating", pendingUpdates.size, "pending items...");
    for (const [key, itemData] of pendingUpdates.entries()) {
        await updateSingleLineItemFromData(itemData);
    }
    pendingUpdates.clear();
    isAmountAdjusting = false;
    thisElement = null;
    isLoadingAdjuster = false;
    adjustAmount(false);
    console.log("All pending updates completed");
}

// ============================================
// CHECKOUT FUNCTION - FIXED
// ============================================
async function initViriffCheckout() {
    let oldBtnText = $("#myBtn").html();
    $("#myBtn").attr("disabled", "true").html("Please wait...");
    await fetch("/cart/update.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            attributes: {
                "Customers email address": $("#client-email").val(),
            },
        }),
    });
    // Wait for all pending updates first
    if (pendingUpdates.size > 0) {
        await updateAllPendingLineItems();
    }
    // Still adjusting? retry
    if (isAmountAdjusting) {
        setTimeout(() => {
            initViriffCheckout();
        }, 500);
        return false;
    }
    // FIXED: Re-run adjustAmount to correctly refresh isAmountAdjust global flag
    adjustAmount(false);
    if (
        ShopifyAnalytics.meta.page.customerId
        && (isAmountAdjust || $(".shipping-line-item--radio input[type='radio']:checked").val() == "Click and collect")
    ) {
        $.getJSON("/cart.js", function (data) {
            $.post("https://goldunion.codevibez.com/veriff/index.php", {
                shop: "goldunion-uk.myshopify.com",
                customer: ShopifyAnalytics.meta.page.customerId ?? "",
                cart: data,
                email: $("#client-email").val(),
                shipping: {
                    name: $(".shipping-line-item--radio input[type='radio']").length > 0
                        ? $(".shipping-line-item--radio input[type='radio']:checked").val()
                        : "",
                    agent: $("#agency-id").length > 0 ? $("#agency-id").val() : "",
                },
            }, (result) => {
                window.location = result.order.invoice_url;
            });
        });
    } else {
        window.location = window.location.origin + "/checkout";
    }
}

// ============================================
// ADJUST AMOUNT DISPLAY - FIXED (early return bug removed)
// ============================================
function adjustAmount(updateValue) {
    let addedAmount = 0;
    isAmountAdjust = false; // FIXED: Now correctly sets the global variable
    if ($(".adjust-value").length > 0) {
        isFistTimePageLoad = false;
        $(".adjust-value").each(function () {
            let symbol = $(this).attr("data-adjust_symbol") || "";
            let amount = parseFloat($(this).attr("data-adjust_amount")) || 0;
            let itemAmount = parseFloat($(this).attr("data-value")) || 0;
            let amt = 0;
            if (amount > 0) {
                isAmountAdjust = true;
            }
            let qty = parseInt($(this).parents(".cart__item").find(".js-qty__num").val()) || 1;
            if (symbol == "+") {
                amt += amount;
                itemAmount += amount;
            } else if (symbol == "-") {
                amt -= amount;
                itemAmount -= amount;
            }
            addedAmount += amt * qty;
            if ($(".cart__drawer-form").length > 0) {
                $(this).parents(".cart__item").find(".pricediv").html(
                    theme.Currency.formatMoney(itemAmount * 100),
                );
            }
            if (updateValue) $(this).val(itemAmount);
        });
        $("#main--shipping-div").hide();
        if (isAmountAdjust) {
            $("#main--shipping-div").show();
        }
        let cartTotalItem = $(".main__cart__item-sub--subtotal");
        let total = theme.Currency.formatMoney(
            parseInt(cartTotalItem.data("total")) + addedAmount * 100,
        );
        // FIXED: Remove old element first
        $(".main__cart__item-sub--subtotal-adjust").remove();
        // FIXED: Check if container exists BEFORE appending, no early return bug
        if ($(".cart__item--subtotal--adjust").length > 0) {
            $(".cart__item--subtotal--adjust").append(
                "<div class=\"main__cart__item-sub--subtotal-adjust\"></div>",
            );
            $(".main__cart__item-sub--subtotal--adjust").hide();
            $(".main__cart__item-sub--subtotal-adjust").html(total);
            return;
        }
        if ($(".cart__drawer-form").length > 0) {
            $(".cart__drawer-form .main__cart__item-sub--subtotal .wholesale-cart-total span").html(total);
            return;
        }
    }
}
// ============================================
// CONTACT FORM VALIDATION AND SUBMISSION
// ============================================
function validatePhoneNumber(input_str) {
    var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    return re.test(input_str);
}

let agencyClosures = [];
const csvUrl = window.agencyCsvUrl;
fetch(csvUrl)
    .then(response => {
        if (!response.ok) {
            throw new Error("HTTP " + response.status);
        }
        return response.text();
    })
    .then(csv => {
        const rows = csv.trim().split(/\r?\n/);
        // Detect separator automatically
        const separator = rows[0].includes(";") ? ";" : ",";
        // Remove header
        rows.shift();
        agencyClosures = rows
            .filter(row => row.trim() !== "")
            .map(row => {
                const cols = row.split(separator);

                return {
                    "Agence": (cols[0] || "").trim(),
                    "Date Fermeture": (cols[1] || "").trim(),
                    "Date réouverture": (cols[2] || "").trim(),
                };
            });
        // console.log("Agency Closures:", agencyClosures.length);
        // console.table(agencyClosures);
    })
    .catch(console.error);
function convertFrenchDate(value) {
    if (!value) return null;
    value = value.toString().trim();
    // dd-mm-yy  (20-08-26)
    if (/^\d{2}-\d{2}-\d{2}$/.test(value)) {
        const p = value.split("-");
        return new Date(
            2000 + parseInt(p[2], 10), // 26 -> 2026
            parseInt(p[1], 10) - 1,
            parseInt(p[0], 10),
        );
    }
    // yyyy-mm-dd
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const p = value.split("-");
        return new Date(
            parseInt(p[0], 10),
            parseInt(p[1], 10) - 1,
            parseInt(p[2], 10),
        );
    }
    // dd/mm/yyyy
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
        const p = value.split("/");
        return new Date(
            parseInt(p[2], 10),
            parseInt(p[1], 10) - 1,
            parseInt(p[0], 10),
        );
    }
    return new Date(value);
}
function parseBookingDate(value) {
    if (!value) return null;
    value = value.trim();
    // yyyy-mm-dd
    if (value.indexOf("-") > -1) {
        const p = value.split("-");
        return new Date(
            parseInt(p[0], 10),
            parseInt(p[1], 10) - 1,
            parseInt(p[2], 10),
        );
    }
    // dd/mm/yyyy
    if (value.indexOf("/") > -1) {
        const p = value.split("/");
        return new Date(
            parseInt(p[2], 10),
            parseInt(p[1], 10) - 1,
            parseInt(p[0], 10),
        );
    }
    return new Date(value);
}
function normalizeAgency(name) {
    return name
        .toString()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/-/g, " ")
        .replace(/\s+/g, " ")
        .trim();
}
function isAgencyClosed(agency, bookingDate) {
    if (!agency || !bookingDate) {
        return {
            status: false,
        };
    }
    const selectedAgency = normalizeAgency(agency);
    // bookingDate format: yyyy-mm-dd
    const selectedDate = $.datepicker.parseDate("yy-mm-dd", bookingDate);
    selectedDate.setHours(0, 0, 0, 0);
    const selectedTime = selectedDate.getTime();
    for (const row of agencyClosures) {
        if (!row["Agence"]) continue;
        if (normalizeAgency(row["Agence"]) !== selectedAgency) continue;
        const closeDate = convertFrenchDate(row["Date Fermeture"]);
        const reopenDate = convertFrenchDate(row["Date réouverture"]);
        if (!closeDate || !reopenDate) continue;
        closeDate.setHours(0, 0, 0, 0);
        // Reopen the next day
        reopenDate.setDate(reopenDate.getDate() + 1);
        reopenDate.setHours(0, 0, 0, 0);
        const closeTime = closeDate.getTime();
        const reopenTime = reopenDate.getTime();
        // console.log("================================");
        // console.log("Agency :", row["Agence"]);
        // console.log("Booking:", selectedDate);
        // console.log("Closed :", closeDate);
        // console.log("Reopen :", reopenDate);
        if (selectedTime >= closeTime && selectedTime < reopenTime) {
            //   console.log("🚫 CLOSED");
            return {
                status: true,
                close: closeDate,
                reopen: reopenDate,
                row: row,
            };
        }
    }
    //   console.log("✅ AVAILABLE");
    return {
        status: false,
    };
}
function sendContactFormAction(formSelector) {
    var phone = $(formSelector).find(".custom_mobile_fileds").val();
    var dateofbith = $(formSelector).find("#datepic_client_date").val();
    // console.log("Selected Date:", dateofbith);
    var meeting_time = $(formSelector).find("select[name=client_time]").val();
    // console.log(meeting_time);
    if (
        !validatePhoneNumber(phone)
        || dateofbith == ""
        || meeting_time == "Heure"
    ) {
        if (!validatePhoneNumber(phone)) {
            $(formSelector).find(".contact-error-message").show();
            $(formSelector).find(".mobile_label_input").addClass("mobile-error-show");
            $(formSelector).find(".date-error-message").hide();
            $(formSelector).find(".date_main-wrapp").removeClass("mobile-error-show");
            $(formSelector).find(".time-error-message").hide();
            $(formSelector).find(".time_main-wrapp").removeClass("mobile-error-show");
        } else if (dateofbith == "") {
            $(formSelector).find(".date-error-message").show();
            $(formSelector).find(".date_main-wrapp").addClass("mobile-error-show");
            $(formSelector).find(".contact-error-message").hide();
            $(formSelector).find(".mobile_label_input").removeClass("mobile-error-show");
            $(formSelector).find(".time-error-message").hide();
            $(formSelector).find(".time_main-wrapp").removeClass("mobile-error-show");
        } else if (meeting_time == "Heure") {
            $(formSelector).find(".date-error-message").hide();
            $(formSelector).find(".date_main-wrapp").removeClass("mobile-error-show");
            $(formSelector).find(".contact-error-message").hide();
            $(formSelector).find(".mobile_label_input").removeClass("mobile-error-show");
            $(formSelector).find(".time-error-message").show();
            $(formSelector).find(".time_main-wrapp").addClass("mobile-error-show");
        }
        return false;
    }
    /* ==========================
         NEW AGENCY HOLIDAY CHECK
      ========================== */
    var agency = "";
    var data_handle = $(formSelector).parents(".tab_data_main").attr("data-handle");
    if (data_handle == "En agence") {
        agency = $(formSelector).find("#agency-id option:selected").val();
    }
    //   console.log("==================================");
    //   console.log("Selected Agency:", agency);
    //   console.log("Holiday Rows:", agencyClosures.length);
    let agencyFound = false;
    agencyClosures.forEach(function (row, index) {
        if (!row["Agence"]) return;
        const excelAgency = row["Agence"].toString().trim().toLowerCase();
        const selectedAgency = agency.toString().trim().toLowerCase();
        if (excelAgency === selectedAgency) {
            agencyFound = true;
            //   console.log("✅ MATCH FOUND");
            //   console.log("Row:", index);
            //   console.log("Excel Agency:", row["Agence"]);
            //   console.log("Close:", row["Date Fermeture"]);
            //   console.log("Reopen:", row["Date réouverture"]);
            //   console.log("Complete Row:", row);
        }
    });
    if (!agencyFound) {
        // console.warn("❌ NO MATCH FOUND");
        // console.log("Selected:", agency);
        // console.log("Available agencies:");
        agencyClosures.forEach(function (row) {
            //   console.log(row["Agence"]);
        });
    }
    console.log("==================================");
    var holiday = isAgencyClosed(agency, dateofbith);
    //   console.log("Holiday:", holiday);
    if (holiday.status) {
        alert(
            "This agency is closed from "
            + $.datepicker.formatDate("dd/mm/yy", holiday.close)
            + " to "
            + $.datepicker.formatDate("dd/mm/yy", holiday.reopen),
        );
        return false;
    }
    /* ========================== */
    $(formSelector).find(".contact-error-message").hide();
    $(formSelector).find(".mobile_label_input").removeClass("mobile-error-show");
    $(formSelector).find(".date-error-message").hide();
    $(formSelector).find(".date_main-wrapp").removeClass("mobile-error-show");
    $(formSelector).find(".time-error-message").hide();
    $(formSelector).find(".time_main-wrapp").removeClass("mobile-error-show");
    $(".brn-contact-form-submit")
        .attr("disabled", true)
        .html("Rendez-vous confirmé ...");
    let formAction = "https://goldunion.codevibez.com/api/contact";
    let formEl = document.querySelector(formSelector);
    var formData = new FormData(formEl);
    var object = {
        country_code: $(formSelector + " .iti__selected-dial-code").html(),
        shop: "gold-union-shop.myshopify.com",
    };
    formData.forEach((value, key) => {
        object[key] = value;
    });
    var json = JSON.stringify(object);
    fetch(formAction, {
        method: "POST",
        headers: { "Content-Type": "application/json", },
        body: json,
    })
        .then(response => response.json())
        .then(result => {
            $(".brn-contact-form-submit")
                .removeAttr("disabled")
                .html("Confirmer mon rendez-vous");
            if (result.status == "error") {
                $(".note--success")
                    .addClass("error")
                    .removeClass("success")
                    .html(result.message)
                    .show();
                return;
            }
            $(".note--success")
                .addClass("success")
                .removeClass("error")
                .html("Thank you for contacting us. We will get back to you as soon as possible.")
                .show();
            if (data_handle == "En agence") {
                var agency_name = $(formSelector)
                    .find("#agency-id option:selected")
                    .val();
            } else {
                var agency_name = $(formSelector)
                    .find("#search_input")
                    .val();
            }
            var data_currency = $("html").attr("currency");
            gtag("event", "conversion", {
                send_to: "G-MTHYR484J8",
                "Home or Agency": data_handle,
                "Agency name (city)": agency_name,
                currency: data_currency,
            });
        })
        .catch(error => {
            console.error(error);
            $(".brn-contact-form-submit")
                .removeAttr("disabled")
                .html("Confirmer mon rendez-vous");
        });
    return false;
}
// ============================================
// GOOGLE MAPS AUTOCOMPLETE
// ============================================
var searchInput = "search_input";
$(document).ready(function () {
    var autocomplete;
    autocomplete = new google.maps.places.Autocomplete(document.getElementById(searchInput), {
        types: ["geocode"],
        componentRestrictions: { country: "fr" },
    });
    google.maps.event.addListener(autocomplete, "place_changed", function () {
        var near_place = autocomplete.getPlace();
        if (document.getElementById("loc_lat")) {
            document.getElementById("loc_lat").value = near_place.geometry.location.lat();
        }
        if (document.getElementById("loc_long")) {
            document.getElementById("loc_long").value = near_place.geometry.location.lng();
        }
        if (document.getElementById("latitude_view")) {
            document.getElementById("latitude_view").innerHTML = near_place.geometry.location.lat();
        }
        if (document.getElementById("longitude_view")) {
            document.getElementById("longitude_view").innerHTML = near_place.geometry.location.lng();
        }
    });
});
$(document).on("change", "#" + searchInput, function () {
    if (document.getElementById("latitude_input")) {
        document.getElementById("latitude_input").value = "";
    }
    if (document.getElementById("longitude_input")) {
        document.getElementById("longitude_input").value = "";
    }
    if (document.getElementById("latitude_view")) {
        document.getElementById("latitude_view").innerHTML = "";
    }
    if (document.getElementById("longitude_view")) {
        document.getElementById("longitude_view").innerHTML = "";
    }
});
// ============================================
// SHIPPING AND ACCORDION HANDLERS
// ============================================
$(document).on("change", ".shipping-line-item--radio input[type='radio']", function () {
    $(".agent-dropdown").hide();
    if ($(this).data("agent") == true) {
        $(this).parents(".shipping-line-item--radio").find(".agent-dropdown").show();
    }
});
$(document).on("click", ".accordion-section-wrapper-main .custom_accordion-btn", function () {
    $(this).parents(".accordion-section-wrapper-main").find(".accordion-section-content_last").slideToggle();
});